import {useState,React} from 'react';
import './styles.css';
import './homepage.css';
import '../App.css';
import './Project.css';
import BottomBar from './BottomBar';
import { IonIcon } from '@ionic/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import SwiperCore, { EffectCoverflow, Pagination, Navigation } from 'swiper';
// import './flower.css';
import CertificateCard from './CertificateCard';
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import Footer from './Footer'
import { Link } from 'react-router-dom';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import p1 from '../images/img_1.jpg';
import CircularMenu from './CircularMenu';
import VideoModal from './VideoModal';
const handleDownload = () => {
  const link = document.createElement('a');
  link.href = './resume.docx';
  link.download = 'resume.docx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
const projects = [
    {
      image: './img_1.jpg',
      title: 'Project 1',
      link: 'https://example.com/project1'
    },
    {
      image: 'path_to_your_image/img_2.jpg',
      title: 'Project 2',
      link: 'https://example.com/project2'
    },
    {
      image: 'path_to_your_image/img_3.jpg',
      title: 'Project 3',
      link: 'https://example.com/project3'
    },
    {
      image: 'path_to_your_image/img_4.jpg',
      title: 'Project 4',
      link: 'https://example.com/project4'
    }
  ];
const Certificates = () => {
    // const navigate = useNavigate();

    // function redirectToProjectsPage() {
    //     navigate('/projects', { replace: true });
    const [showModal, setShowModal] = useState(false);

const handleOpenModal = () => {
  setShowModal(true);
}

const handleCloseModal = () => {
  setShowModal(false);
}
    // }
    return (
        <div class="homepagedark">
      <div class="bg1">
        <div class="bg-item"></div>
        {/* <div class="line-group">
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
        </div> */}
      </div>
      <div class="ololade-group">
        <div class="ololade2">
          <span>CERTIFICATES</span>
          <span class="span2">.</span>
        </div>
        {/* <button class="download-btndark" onClick={handleDownload}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Resume</div>
          <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button> */}
      </div>
      <div class="ololade-group">
        <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    bottom: 740,
    left: 980,
  }}>
    <button class="download-btndark" onClick={handleOpenModal}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Visume</div>
          <VideoModal 
        show={showModal} 
        handleClose={handleCloseModal} 
        videoSrc="https://www.youtube.com/embed/dQw4w9WgXcQ" 
      />
          {/* <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          /> */}
        </button>
  </div>
  <div style={{
    position: 'absolute',
    bottom: 740,
    left: 1150,
  }}>
    <button class="download-btndark" onClick={handleDownload}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Resume</div>
          <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button>
  </div>
</div>
        
        
      </div>
      <div className="container">
      <h1 className="heading">Portfolio</h1>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        slidesPerView={'auto'}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
        }}
        pagination={{ el: '.swiper-pagination', clickable: true }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          clickable: true,
        }}
        className="swiper_container"
      >
        {projects.map((project, index) => (
          <SwiperSlide key={index}>
            <CertificateCard
              image={project.image}
              title={project.title}
              link={project.link}
            />
          </SwiperSlide>
        ))}

        <div className="slider-controler">
          <div className="swiper-button-prev slider-arrow">
            <ion-icon name="arrow-back-outline"></ion-icon>
          </div>
          <div className="swiper-button-next slider-arrow">
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </div>
          {/* <div className="swiper-pagination"></div> */}
        </div>
      </Swiper>
    </div>
      <BottomBar />
      <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    bottom: 310,
    right: 100,
  }}>
    <CircularMenu />
  </div>
</div>
    </div>
    );
};

export default Certificates;
